import { Column } from '@/shared/components/table/table.model';
import { ElementDetailsModalComponent } from '@/modules/elements/components/element-details-modal/element-details-modal.component';
import { ELEMENT_COLUMNS } from './elements.const';
import { Observable } from 'rxjs';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ElementDataSource } from '@/modules/elements/elements.datasource';
import { ElementsGQL, ElementFragment } from '@/core/graphql/graphql';
import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import { filter, first } from "rxjs/operators";
import { ElementDialog } from "@/modules/elements/components/element-details-modal/element-dialog.model";
import { DataSourceName } from '@/shared/components/table/table.component';

@Component({
  selector: 'cosmos-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.scss'],
})
export class ElementsComponent implements OnInit {
  @ViewChild('elementPreview', { static: true }) public elementPreview: TemplateRef<any>;

  public _loading$: Observable<boolean>;
  public _columns: Column<ElementFragment>[] = [];
  public readonly _dataSource: ElementDataSource;
  public readonly _dataSourceName = DataSourceName.Elements;

  public constructor(
    private readonly _elementsGql: ElementsGQL,
    private readonly _dialog: CosmosDialogService,
  ) {
    this._dataSource = new ElementDataSource(_elementsGql);
    this._loading$ = this._dataSource._loading$;
  }

  public ngOnInit(): void {
    this._columns = ELEMENT_COLUMNS(this.elementPreview);
    this._dataSource.loadData(null);
  }

  public openDetails(data: ElementFragment): void {
    const dialogRef = this._dialog.open<ElementDetailsModalComponent, { elementId: number }, ElementDialog>(ElementDetailsModalComponent, {
      data: {
        elementId: data.id,
      },
      style: CosmosDialogStyle.Dark,
    });

    dialogRef.afterClosed().pipe(
      first(),
      filter(data => !!data?.refreshData),
    ).subscribe(_ => this._dataSource.loadData(null));
  }
}
